<template>
  <div class="page-gifts">
    <div class="wrap">
      <TopBoard ref="board" />
      <div class="title-bar clearfix">
        <span class="title">全部礼包</span>
        <a
          href="/personal/my-reward?gift_type=package"
          target="_blank"
          @click="$util.clickStat(`LBZX/LQJL`, `礼包中心/领取记录`)"
        >
          <span class="action"><i></i> 礼包领取记录></span>
        </a>
      </div>
      <GiftAction @change="curGameId = $event" @change-vip="curVip = $event" />
      <div class="result-list clearfix">
        <GameItem
          v-for="item in list"
          :key="item.id"
          :game="item"
          :stat-params="statParams"
        />
        <InfiniteLoading
          spinner="bubbles"
          :identifier="loadId"
          @infinite="fetchGiftList"
        >
          <div slot="no-results" class="result-empty">抱歉，找不到相关礼包</div>
          <i slot="no-more"></i>
        </InfiniteLoading>
      </div>
      <template v-if="!list.length">
        <div class="title-bar clearfix">
          <span class="title">推荐礼包</span>
        </div>
        <div class="result-list clearfix">
          <GameItem
            v-for="item in allGame"
            :key="item.id"
            :game="item"
            :stat-params="statParams"
          />
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import TopBoard from '~/components/gifts/TopBoard'
import GiftAction from '~/components/gifts/GiftAction'
import GameItem from '~/components/gifts/GameItem'
export default {
  components: {
    TopBoard,
    GiftAction,
    GameItem
  },
  data() {
    return {
      list: [],
      page: 1,
      size: 8,
      allGame: [],
      curGameId: 0,
      curVip: 0,
      total: 0,
      loadId: -1,
      statParams: {
        eid: 'LBZX/QBLB/',
        eid_desc: '礼包中心/全部礼包/'
      }
    }
  },
  watch: {
    curGameId(val) {
      this.page = 1
      this.list = []
      this.total = 0
      if (val !== -1) {
        this.curVip = 0
        this.loadId = val
        this.fetchListCount()
      }
    },
    curVip(val) {
      this.page = 1
      this.list = []
      this.total = 0
      if (val) {
        this.curGameId = -1
        this.loadId = val
        this.fetchListCount('vip')
      }
    }
  },
  methods: {
    clientCreated() {
      this.fetchListCount()
    },
    fetchParams() {
      if (this.curVip) {
        return { vip_level: this.curVip }
      }
      return { game_ids: this.curGameId }
    },
    fetchListCount() {
      this.$request('giftsPackageListCount', {
        body: this.fetchParams()
      }).then((data = {}) => (this.total = data.count))
    },
    fetchGiftList($state) {
      if (this.curGameId !== -1 || this.curVip) {
        this.$request('giftsPackageList', {
          body: {
            ...this.fetchParams(),
            page: this.page,
            size: this.size
          }
        }).then((data = {}) => {
          const list = data.set_list || []
          if (this.curGameId === 0 && this.page === 1) {
            this.allGame = list.slice(0, 8)
          }
          this.list = [...this.list, ...list]
          this.page += 1
          if (this.list.length) {
            $state.loaded()
          }
          if (list.length < this.size) {
            $state.complete()
          }
        })
      } else {
        this.list = []
        this.total = 0
        $state.complete()
      }
    }
  }
}
</script>

<style lang="scss" src="~/assets/scss/gifts.scss"></style>
